import React, { useState } from 'react';
import { css } from 'astroturf';

const styles = css`
  .container {
    margin: 2rem 0 !important;
  }

  .row {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    min-height: calc(50px + 2rem);
    padding: 1rem;
    background: rgb(30, 30, 63);
    border-radius: calc(1rem + 5px);
    margin-bottom: 1rem;
    justify-content: flex-start;
    align-items: center;
  }

  .box {
    background: green;
    width: 50px;
    height: 50px;
    border-radius: 5px;
    opacity: 1;
    transition: all 1s ease;

    @starting-style {
      filter: blur(5px);
      background: red;
      opacity: 0;
    }
  }

  .button {
    background: #107db5;
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s ease;
    margin: 0 auto;
    display: block;

    &:hover {
      background: #0d6695;
    }

    &:active {
      transform: scale(0.98);
    }
  }
`;

const StartingStyleDemo = () => {
  const [boxes, setBoxes] = useState([]);

  const addBox = () => {
    setBoxes([...boxes, Date.now()]);
  };

  return (
    <div className={styles.container}>
      <div className={styles.row}>
        {boxes.map((id) => (
          <div key={id} className={styles.box} />
        ))}
      </div>
      <button className={styles.button} onClick={addBox}>
        Add Box
      </button>
    </div>
  );
};

export default StartingStyleDemo;
